import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const ApiFinancialYTD = () => {
  const getSummary = async (selectedMonths) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedMonths = selectedMonths.slice();
    const allIndex = _selectedMonths.indexOf('All');
    if (allIndex > -1) _selectedMonths.splice(allIndex, 1);
    const filter = { DimDateKeys: _selectedMonths };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/financialperformanceYTD/${company_id}/${company_org_id}/summary${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getDetail = async (selectedYearMonth) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');
    
    let queryjson = [];
    queryjson[0] = selectedYearMonth;
    let filter = { DimDateKey: queryjson };

    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/financialperformanceYTD/${company_id}/${company_org_id}/detail${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getSummary,
    getDetail,
  };
};

export default ApiFinancialYTD();
